<style scoped lang="scss">
    .page-daywork-configs {
        .c-datetime-range {
            min-width: 360px;
        }
    }
</style>

<template>
    <div class="page-daywork-configs">
        <div class="toolbars mrgb5">
            <div class="buttons mrgb5">
                <div class="fl">
                    <el-button class="mrgr5 mrgb5" type="primary" size="medium" @click="_edit()"><i class="fa fa-edit"></i> 新增配置</el-button>
                </div>
                <div class="fr">
                    <el-checkbox class="mrgr5 mrgb5" v-model="listQuery.isFilterArea" label="仅看当前服务区" border size="medium"
                        @change="_search()"></el-checkbox>
                    <el-input class="c-el-input mrgr5 mrgb5" placeholder="请输入员工姓名/电话" clearable v-model="listQuery.keywords"
                        size="medium"></el-input>
                    <el-button type="primary" size="medium" @click="_search()"><i class="fa fa-search"></i> 查询</el-button>
                    <!--<el-button class="mrgr5 mrgb5" type="danger" size="medium" @click="_updateState()"><i class="el-icon-refresh"></i> 更新工作状态</el-button>-->
                    <el-tooltip effect="dark" placement="top">
                        <div slot="content">
                            1、只配置需要查看工作记录的员工信息。<br />
                            2、员工只需要配置归属到一个服务区即可，工作纪录也需要在相同服务区去查看，会自动统计所有服务区的工作数据。<br />
                            3、扫一扫默认不会统计到有效工作时间内，需要将员工身份配置为“巡检”才能计算在内。<br />
                        </div>
                        <el-tag class="mrgl5" type="warning" size="medium"><i class="el-icon-view f12"></i> 查看说明</el-tag>
                    </el-tooltip>
                </div>
                <div class="clearb"></div>
            </div>
        </div>
        <el-table :data="tableData" style="width: 100%" border size="medium">
            <el-table-column label="名称" prop="name" width="200"></el-table-column>
            <el-table-column label="联系电话" prop="tel"></el-table-column>
            <el-table-column label="员工身份" prop="roleDesc"></el-table-column>
            <el-table-column label="归属平台" prop="platform"></el-table-column>
            <el-table-column label="归属服务区" prop="area"></el-table-column>
            <el-table-column label="创建时间" prop="creationTime" :formatter="tableDateFormat" v-if="$root.isPc"></el-table-column>
            <el-table-column label="操作" align="center" width="160" fixed="right">
                <template slot-scope="scope">
                    <el-button type="primary" plain size="mini" @click="_edit(scope.row)">编辑</el-button>
                    <el-button type="danger" plain size="mini" @click="_delete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination-container" v-if="isPagination">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" 
                :current-page="listQuery.page" :page-sizes="appPageSizes" :page-size="listQuery.size" 
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>

        <!--编辑工作配置-->
        <edit :ref="refEdit" @refreshData="_search()"></edit>
    </div>
</template>

<script>
import enumConfigs from "@/mixins/enumConfigs"
import * as funEmployees from '@/api/employees'
import edit from "./components/editWork"
import moment from "moment"
export default {
    name: "pageDayWorkConfigs",
    mixins: [enumConfigs],
    components: { edit },
    data() {
        let that = this
        return {
            refEdit: "refDayWorkConfigsToEditWork",
            isPagination: false,
            listQuery: {
                isFilterArea: false,
                area: "",
                keywords: "",
                page: 1,
                size: window.$common.appPageSize

            },
            total: null,
            tableData: []
        }
    },
    watch: {
        "$store.getters.serviceArea"(v) {
            this.mxIsSameActiveTabWithRoute(() => {
                this._search()
            })
        }
    },
    mounted() {
        this.getDataList()
    },
    methods: {
        handleSizeChange(val) {
            window.$common.fullLoading()
            this.listQuery.size = val
            this.getDataList()
        },
        handleCurrentChange(val) {
            window.$common.fullLoading()
            this.listQuery.page = val
            this.getDataList()
        },
        getDataList() {
            this.listQuery.area = this.listQuery.isFilterArea ? this.$store.getters.serviceArea : ""
            this.listQuery.keywords = this.listQuery.keywords.trim()
            window.$common.fullLoading()
            funEmployees.GetEmployeeDayWorkConfigs(this.listQuery).then(response => {
                window.$common.closeFullLoading()
                this.total = response.totalCount
                this.isPagination = response.totalCount > 0 || false
                if (response && response.items && response.items.length > 0) {
                    this.tableData = response.items.map(x => {
                        x.roleDesc = this.arrEmployeeRole && this.arrEmployeeRole.find(y => y.value === x.role) ? this.arrEmployeeRole.find(y => y.value === x.role).desc : ""
                        return x
                    })
                } else {
                    this.tableData = []
                }
            })
        },
        _updateState() {
            let psTime = ""
            let peTime = ""
            if (this.selectedTime && this.selectedTime[0] && moment(this.selectedTime[0]).isValid()) {
                psTime = moment(this.selectedTime[0]).format("YYYY-MM-DD HH:mm:ss")
            }
            if (this.selectedTime && this.selectedTime[1] && moment(this.selectedTime[1]).isValid()) {
                peTime = moment(this.selectedTime[1]).format("YYYY-MM-DD HH:mm:ss")
            }
            let params = {
                area: this.listQuery.area,
                startDate: psTime,
                endDate: peTime
            }
            if (!params.startDate || !params.endDate) {
                this.warningMsg("请选择更新时间段!")
                return false
            }
            window.$common.fullLoading()
            funEmployees.HandleDayWork(params).then(() => {
                window.$common.closeFullLoading()
                this.successMsg("工作状态更新成功!")
            })
        },
        _edit(row) {
            this.$refs[this.refEdit].open(row)
        },
        _search() {
            this.listQuery.page = 1
            this.getDataList()
        },
        _delete(row) {
            this.confirm("确定要删除当前员工配置吗?").then(() => {
                funEmployees.DeleteEmployeeDayWorkConfig({ id: row.id }).then(res => {
                    this.getDataList()
                    this.successMsg("删除成功!")
                })
            })
        }
    }
}
</script>